import { render, staticRenderFns } from "./reisetermin-view-releasepruefung-card.vue?vue&type=template&id=3c116e8f"
import script from "./reisetermin-view-releasepruefung-card.vue?vue&type=script&lang=js"
export * from "./reisetermin-view-releasepruefung-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports